import { useQuery } from "@tanstack/react-query"

import { getLocations } from "@/api/getLocations.ts"

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "./ui/select.tsx"

export default function LocationSelector({
  value,
  onChange,
}: {
  value: number
  onChange: (id: number) => void
}) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["locations"],
    queryFn: () => getLocations(),
  })

  return (
    <Select onValueChange={(v) => onChange(Number(v))} value={value ? value.toString() : undefined}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select a location" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Locations</SelectLabel>
          {isPending && <>Loading...</>}
          {isError && <>Network Error</>}
          {data?.map((loc) => (
            <SelectItem key={loc.id} value={loc.id.toString()}>
              {loc.name}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
